import { render, staticRenderFns } from "./SupervisorBulkUpdate.vue?vue&type=template&id=c0255598&"
import script from "./SupervisorBulkUpdate.vue?vue&type=script&lang=js&"
export * from "./SupervisorBulkUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports